export default "__VITE_ASSET__BZQEVBIx__"